// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
<div>
  <v-navigation-drawer app clipped persistent enable-resize-watcher fixed v-model="showDrawer" class="noprint">
    <v-list subheader dense>
      <v-list-item>
        <v-list-item-content>
          <img v-bind:src="'static/logo.png'" style="width:100%; padding-top: 8px;">
        </v-list-item-content>
        <v-list-item-action v-if="isMobile">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon text v-on="on"><v-icon x-large>account_circle</v-icon></v-btn>
              </template>
              <v-list>
                <v-list-item :to="{name: 'userMe'}">
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item>
                <v-list-item @click="logout">
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
      </v-list-item>

      <v-list-item @click="localSearchClear">
        <v-list-item-action>
          <v-icon>mdi-home-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-shape-outline">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Categories</v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item @click="localSearchClear()">
          <v-list-item-action>
            <v-icon>search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>All</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-for="category in getCategories" :key="category.id" @click="localSearchCategory(category)">
          <v-list-item-action>
            <v-icon>search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ category.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group prepend-icon="mdi-label-multiple-outline" :disabled="tags.length === 0">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Tags</v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-if="tags.length > 0">
          <v-list-item v-for="tag in tags" :key="tag" @click="localSearchTag(tag)">
          <v-list-item-action>
            <v-icon>search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ tag }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </template>
        <template v-else>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>No tags found</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list-group>
      <v-list-item :to="{name: 'qrCode'}">
        <v-list-item-action>
          <v-icon>mdi-qrcode-scan</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>QR Code Generator</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

        <template v-for="(item, i) in menu">
          <template v-if="item.items">
            <v-list-group :key="i">
              <template slot="activator">
                <v-list-item-action>
                  <v-icon>{{ item.action }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="subItem in item.items" :key="subItem.title" :to="{name: subItem.route}">
                <v-list-item-action> </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list-group>
          </template>
          <template v-else>
            <v-list-item :to="{name: item.route}" :key="i">
              <v-list-item-action>
                <v-icon>{{ item.action }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
        <v-divider></v-divider>
        <v-list-item style="background-color: rgba(0,0,0,0.07);">
          <v-list-item-action>
            <v-icon></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>v{{ version }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
    </v-list>
  </v-navigation-drawer>
  <v-app-bar app fixed clipped-left clipped-right class="noprint">
    <v-app-bar-nav-icon @click.stop="showDrawer = !showDrawer"><v-icon>menu</v-icon></v-app-bar-nav-icon>
    <search-bar :categories="getCategories" :disabled="disableSearch" style="margin:15px;"></search-bar>
    <v-menu offset-y v-if="!isMobile">
      <template v-slot:activator="{ on }">
        <v-btn icon text v-on="on"><v-icon x-large>account_circle</v-icon></v-btn>
      </template>
      <v-list>
        <v-list-item :to="{name: 'userMe'}">
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
  <v-main>
    <router-view></router-view>
  </v-main>
  </div>
</template>

<script>
  import { removeCookie } from 'tiny-cookie'

  import SearchBar from '@/components/SearchBar'
  import {mapActions, mapGetters, mapMutations} from 'vuex'
  import {PERMISSIONS} from '@sdgsystems/vue-common/components/constants'
  import {AXIOSAPI} from '@sdgsystems/vue-common/components/requests-common'
  import {checkPermission} from '@sdgsystems/vue-common/components/user'
  import ApiRequests from '@/api/ApiRequests'

  import {version} from '../../package.json'

  export default {
    components: {
      SearchBar
    },

    data () {
      return {
        showCategories: false,
        showDrawer: true,
        showTags: true,
        version: version,
        showSSOSettings: false
      }
    },

    mounted () {
      if (localStorage.getItem('night-theme')) {
        this.$vuetify.theme.dark = true
      } else {
        this.$vuetify.theme.dark = false
      }
    },

    created () {
      this.showDrawer = !this.isMobile
      this.initialize()
    },

    computed: {
      ...mapGetters([
        'accessRules',
        'getCategories',
        'getImages'
      ]),

      adminMenu: function () {
        var adminMenuList = []

        if (checkPermission(this.accessRules, 'apikeys', PERMISSIONS.CREATE)) {
          adminMenuList.push({
            title: 'API Keys',
            route: 'apikeys',
            action: 'mdi-key-outline'
          })
        }

        if (checkPermission(this.accessRules, 'image-categories', PERMISSIONS.MODIFY)) {
          adminMenuList.push({
            title: 'Categories',
            route: 'categories',
            action: 'mdi-shape-outline'
          })
        }

        if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
          adminMenuList.push({
            title: 'Usage',
            route: 'usage',
            action: 'mdi-chart-donut'
          })
        }

        if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
          adminMenuList.push({
            title: 'Shared Collections',
            route: 'shares',
            action: 'mdi-share-variant-outline'
          })
        }

        if (checkPermission(this.accessRules, 'users', PERMISSIONS.CREATE)) {
          adminMenuList.push({
            title: 'Users',
            route: 'users',
            action: 'mdi-account-group-outline'
          })
        }

        if (checkPermission(this.accessRules, 'webhooks', PERMISSIONS.CREATE)) {
          adminMenuList.push({
            title: 'Webhooks',
            route: 'webhooks',
            action: 'webhook'
          })
        }

        if (checkPermission(this.accessRules, 'ssosettings', PERMISSIONS.CREATE) && this.showSSOSettings) {
          adminMenuList.push({
            title: 'SSO Settings',
            route: 'ssoSettings',
            action: 'mdi-shield-account-outline'
          })
        }

        return {
          action: 'mdi-security',
          title: 'Admin',
          items: adminMenuList
        }
      },

      adminMenuAvailable: function () {
        return (this.adminMenu.items.length > 0)
      },

      configurationMenu: function () {
        var configurationMenuList = []

        if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
          configurationMenuList.push({
            title: 'Configuration',
            route: 'configSettings',
            action: 'settings'
          })
        }

        if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
          configurationMenuList.push({
            title: 'Organizations',
            route: 'organizations',
            action: 'filter_list'
          })
        }

        if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
          configurationMenuList.push({
            title: 'Settings',
            route: 'settings',
            action: 'settings'
          })
        }

        if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
          configurationMenuList.push({
            title: 'Billing',
            route: 'billing',
            action: 'assessment'
          })
        }

        /* if (checkPermission(this.accessRules, 'organizations', PERMISSIONS.MODIFY)) {
          configurationMenuList.push({
            title: 'Stats',
            route: 'configStats',
            action: 'assessment'
          })
        } */

        return {
          action: 'mdi-cog-outline',
          title: 'Configuration',
          items: configurationMenuList
        }
      },

      disableSearch: function () {
        if (this.$route.name === 'images') {
          return false
        }
        return true
      },

      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      menu: function () {
        var menu = []

        if (this.adminMenu.items.length > 0) {
          menu.push(this.adminMenu)
        }

        if (this.configurationMenu.items.length > 0) {
          menu.push(this.configurationMenu)
        }

        return menu
      },

      tags: function () {
        var results = []
        for (var i = 0; i < this.getImages.length; i++) {
          results = results.concat(this.getImages[i].tags)
        }
        return results.filter((v, i, a) => a.indexOf(v) === i)
      }
    },

    methods: {
      ...mapMutations([
        'searchClear',
        'searchCategory',
        'searchTag'
      ]),

      ...mapActions([
        'fetchShares',
        'fetchCategories',
        'getUserData'
      ]),

      initialize: function () {
        this.fetchShares()
        this.getUserData()
        this.fetchCategories()
        this.isSSOAvailable()
      },

      isSSOAvailable: function () {
        ApiRequests.oktaAvailable().then(_ => {
          this.showSSOSettings = true
        }).catch(_ => {
          this.showSSOSettings = false
        })
      },

      logout: function () {
        var parent = '.' + window.location.hostname.split('.').slice(-2).join('.')
        console.log(parent)
        AXIOSAPI.post('auth/logout').then(response => {
          removeCookie('token', {domain: parent})
        }).catch(e => {
          console.error(e)
          // This appears twice and in the request repsonse so that there is no race condition
          // between deleting the cookie and sending the request that requires it
          removeCookie('token', {domain: parent})
        })
        this.$router.push({name: 'login'})
      },

      localSearchClear: function () {
        if (this.$route.name === 'images') {
          this.searchClear()
        }
        this.$router.push({name: 'images'})
      },

      localSearchCategory: function (value) {
        this.searchCategory(value)
        this.$router.push({name: 'images'})
      },

      localSearchTag: function (value) {
        this.searchTag(value)
        this.$router.push({name: 'images'})
      },

      checkIfMobile: function () {
        if (window.innerWidth < 1024) {
          return true
        }
        return false
      }
    }
  }
</script>

<style>
.container {
  padding: 8px !important;
}

@media print {
  /* Prevent the element from printing. */
  .noprint {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// Index.vue?764d01aa